import template from './footer.html';
import controller from './footer.controller';
import './footer.scss';

let footerComponent = {
  bindings: {},
  template,
  controller
};

export default footerComponent;



// WEBPACK FOOTER //
// ./client/app/common/footer/footer.component.js